import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
export const API_BASE = `${BACKEND_URL}/api`;
export const BACKEND_ORIGIN = BACKEND_URL.replace(/\/+$/, "");

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Bearer fallback so it works across preview domains where httpOnly cookies may be blocked
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cliver_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") {
    const cleaned = detail.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
    if (!cleaned) return "Algo deu errado. Tente novamente.";
    return cleaned.length > 220 ? `${cleaned.slice(0, 220)}...` : cleaned;
  }
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function absoluteMediaUrl(url) {
  if (!url) return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url);
      if (parsed.pathname.startsWith("/api/media/")) {
        return `${BACKEND_ORIGIN}${parsed.pathname}${parsed.search}`;
      }
    } catch {
      return url;
    }
    return url;
  }
  return `${BACKEND_ORIGIN}${url.startsWith("/") ? url : `/${url}`}`;
}

export default api;
